// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3iKTN","signatureBlock":"Footer_signatureBlock__1hBPh","signature":"Footer_signature__35wvH"};